import { Checkbox } from '@mui/material';
import { FC } from 'react';
import { Development } from '~/api/types';
import { DevelopmentRow } from '~/components/button/development-row';

/**
 * Same look of the development selection button, for the screens in which more
 * than one development may be picked at once.
 */
export const DevelopmentCheckboxButton: FC<DevelopmentCheckboxButtonProps> = ({
  development,
  checked,
  onToggle,
  disabled,
  badgeLabel,
}) => {
  return (
    <DevelopmentRow
      development={development}
      disabled={disabled}
      badgeLabel={badgeLabel}
      onClick={onToggle}
      trailing={
        // the whole row is clickable, so the checkbox itself only reflects the state
        <Checkbox
          color="primary"
          checked={checked}
          disabled={disabled}
          inputProps={{ 'aria-label': development.name, 'readOnly': true }}
        />
      }
    />
  );
};

export interface DevelopmentCheckboxButtonProps {
  development: Development;
  checked: boolean;
  onToggle: () => void;
  /**
   * Keeps the row visible but locks it, for a development whose notifications are
   * already active: there is nothing to toggle.
   */
  disabled?: boolean;
  badgeLabel?: string;
}
